import React, { useEffect, useState } from 'react';
import { Dialog } from "evergreen-ui";
import { Input, message } from "antd";
import { useListVals } from "../../Firebase/databaseHooks";
import Firebase from "../../Firebase/Firebase";
import {
    read, utils
} from "xlsx";
import FireFetch from "../../Firebase/FireFetch";
import { getDatabase, ref, update } from "firebase/database";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useAuth } from "../../AuthContext/AuthContext";



const db = getDatabase(Firebase);
const auth = getAuth(Firebase);
const moment = require("moment");
const TaskUploadModal = (props) => {
    const { canAccessModule } = useAuth();
    const canCreateTask = canAccessModule("TASKS", "create");

    const [showModal, setShowModal] = useState(props.showModal);
    const [file, setFile] = useState(null);
    const [users] = useListVals(ref(db, "talmidsdb/users"));
    const [userID, setUserID] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setShowModal(props.showModal);
        onAuthStateChanged(auth, function (user) {
            if (user) {
                setUserID(user.uid);
            }
        })
    }, [props]);

    const handleFileUpload = (e) => {
        setFile(e.target.files[0]);
    }
    const arrayToObject = (array) =>
        array.reduce((obj, item) => {
            obj[item[`${props.id}ID`]] = item
            return obj
        }, {});


    function readFile() {
        if (!canCreateTask) {
            message.error("You do not have permission to upload tasks.");
            setLoading(false);
            return;
        }
        if (!file) {
            message.error("Please select a file to upload.");
            setLoading(false);
            return;
        }

        const reader = new FileReader();
        reader.onload = (evt) => {
            // evt = on_file_select event
            /* Parse data */
            const bstr = evt.target.result;
            const wb = read(bstr, { type: "binary" });
            /* Get first worksheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* Convert array of arrays */
            const data = utils.sheet_to_csv(ws, { header: 1 });
            /* Update state */

            const dataArray = FireFetch.convertToJson(data);
            var tempArray = [];
            dataArray.map((item) => {
                var newObject = {};
                Object.keys(item).forEach((key) => {
                    var newKey = key.split(" ").length > 1 ? key.split(" ")[0].toLowerCase() + "" + key.split(" ")[1] :
                        key.split(" ")[0].toLowerCase();
                    newObject[newKey] = item[key] ? item[key] : "";
                });
                tempArray.push(newObject);
            });
            tempArray = tempArray.filter(x => x.task !== "");
            console.log(tempArray);

            console.log(users)
            tempArray.map((item) => {
                item[`${props.id}ID`] = Array(12).fill("ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789abcdefghijklmnopqrstuvwxyz")
                    .map(function (x) { return x[Math.floor(Math.random() * x.length)] }).join('');
                item.assignedTo = item.assignedTo ? users.filter(x => (`${x.firstname} ${x.surname}`.toLowerCase()
                    === item.assignedTo.toLowerCase()))[0] && users.filter(x => (`${x.firstname} ${x.surname}`.toLowerCase()
                        === item.assignedTo.toLowerCase()))[0].userID : "";
                item.createdBy = userID;
                item.createdDate = moment().format("YYYY-MM-DDTh:mm:ss");
                item.dueDate = moment(item.dueDate).format("YYYY-MM-DD");

                delete item.action;
                delete item.key;
                delete item.created;
            })

            const arrayObjects = arrayToObject(tempArray);
            console.log(arrayObjects);

            update(ref(db, "talmidsdb/Tasks"), arrayObjects).then(() => {
                message.success("Tasks uploaded successfully");
                setShowModal(false);
                setLoading(false);
            }).catch((error) => {
                message.error(error);
                setLoading(false);
            });

        };
        reader.readAsBinaryString(file);


    }



    return (
        <>
            <Dialog
                isShown={showModal}
                title="Upload Task"
                onCloseComplete={() => { setShowModal(false) }}
                onConfirm={() => {
                    setLoading(true);
                    readFile();
                }}
                isConfirmDisabled={!canCreateTask || !file}
                isConfirmLoading={loading}
            >
                <div>
                    <Input
                        type="file"
                        style={{ width: "100%" }}
                        accept=".xlsx, .xls, .csv"
                        placeholder="select excel file"
                        size="large"
                        className="mt-2 w-100"
                        disabled={!canCreateTask}
                        onChange={handleFileUpload} />
                </div>

            </Dialog>

        </>
    )
}

export default TaskUploadModal;
